import { SiteGroupFormValidationSchema } from '@/modules/SiteGroups';

export const siteGroupsFormValidationSchema: SiteGroupFormValidationSchema = {
  name: [
    { required: true, message: 'Введіть назву групи' },
    { type: 'string', message: 'Назва має бути строкою' },
    { min: 3, max: 100, message: 'Назва має бути довжиною не менше 3 символів та не більше 100' }
  ],
  siteIds: []
};
